module.exports = __webpack_public_path__ + "media/images/custom-illustration-764c6a23562b642051383f9133949a7f.png";